<template>
  <div class="container">
    <div class="titleWrapper">
      <p class="subtitleItem px-5">Register</p>
      <h2 class="titleItem">{{isOrganization ? "利用者情報登録" : "新規会員登録"}}</h2> 
    </div>

    <div class="card">
      <div class="wide-step-wrapper mt-4 mb-4">
      <user-signup-step state="register" /></div>
      <div class="card-body">
        <form @submit.stop.prevent="submit">
          <div class="form-row justify-content-center">
            <div class="form-group col-lg-12">
              <label
                for="last_name"
                style="
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                  gap: 6px;
                "
              >
                お名前
                <img
                  src="/images/icon_required.png"
                  alt="必須マーク"
                  style="height: 1em"
                />
              </label>
              <div class="d-flex align-items-center">
                <div class="mr-1 text-muted"></div>
                <input
                  v-model="user.last_name"
                  type="text"
                  name="last_name"
                  id="last_name"
                  class="form-control"
                  :class="{ 'is-invalid': errors.last_name }"
                  placeholder="姓"
                  required
                />
                <div class="mr-1 ml-2 text-muted"></div>
                <input
                  v-model="user.first_name"
                  type="text"
                  name="first_name"
                  id="first_name"
                  class="form-control"
                  :class="{ 'is-invalid': errors.first_name }"
                  placeholder="名"
                  required
                />
              </div>
              <div v-if="errors.last_name" class="invalid-feedback d-block">
                {{ errors.last_name[0] }}
              </div>
              <div v-if="errors.first_name" class="invalid-feedback d-block">
                {{ errors.first_name[0] }}
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col">
              <label
                for="password"
                style="
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                  gap: 6px;
                "
              >
                パスワード
                <img
                  src="/images/icon_required.png"
                  alt="必須マーク"
                  style="height: 1em"
                />
              </label>
              <input
                v-model="user.password"
                id="password"
                name="password"
                type="password"
                class="form-control"
                :class="{ 'is-invalid': errors.password }"
                required
              />
              <div v-if="errors.password" class="invalid-feedback d-block">
                {{ errors.password[0] }}
              </div>
            </div>
          </div>

          <div class="row mb-4" style="margin-top: 24px;">
            <div class="col">
              <ul class="passwordInfo mb-0">
                <li class="mb-1">
                  パスワードは、アルファベット（小・大文字を両方含む）と数字の組み合わせ8～32文字で設定してください
                </li>
                <li class="mb-0">
                  <span>パスワードとして使用可能な記号は</span>
                  <span
                    >&nbsp;!&nbsp;$&nbsp;%&nbsp;+&nbsp;/&nbsp;=&nbsp;?&nbsp;[&nbsp;]&nbsp;@&nbsp;</span
                  >
                  <span>です</span>
                </li>
              </ul>
            </div>
          </div>

          <hr class="section-divider" />

          <div class="d-flex justify-content-center text-center">
            <p class="vc-terms">
              <a href="https://yokumiru.jp/terms" target="_blank">利用規約</a>・<a
                href="https://yokumiru.jp/privacy-policy"
                target="_blank"
                >プライバシーポリシー</a
              >をご確認のうえ、同意してからボタンを押してください。
            </p>
          </div>

          <div class="d-flex justify-content-center">
            <div style="width: 300px">
              <div class="form-check">
                <input
                  v-model="agreement.term"
                  value="1"
                  id="agreement_term"
                  class="form-check-input"
                  :class="{ 'is-invalid': errors.agreement_term }"
                  type="checkbox"
                />
                <label
                  for="agreement_term"
                  style="s
                    font-weight: normal;
                    margin-left: 7px
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    cursor: pointer;
                  "
                >
                  利用規約に同意する
                  <img
                    src="/images/icon_required.png"
                    alt="必須マーク"
                    style="height: 1em"
                  />
                </label>
              </div>
              <div v-if="errors.agreement_term" class="invalid-feedback d-block">
                {{ errors.agreement_term[0] }}
              </div>
            </div>
          </div>
          
          <div class="d-flex justify-content-center">
            <div style="width: 300px">
              <div class="form-check" >
                <input
                  v-model="agreement.privacy"
                  value="1"
                  id="agreement_privacy"
                  class="form-check-input"
                  :class="{ 'is-invalid': errors.agreement_privacy }"
                  type="checkbox"
                />
                <label
                  for="agreement_privacy"
                  style="
                    font-weight: normal;
                    margin-left: 7px
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    cursor: pointer;
                  "
                >
                  プライバシーポリシーに同意する
                  <img
                    src="/images/icon_required.png"
                    alt="必須マーク"
                    style="height: 1em"
                  />
                </label>
              </div>
              <div v-if="errors.agreement_privacy" class="invalid-feedback d-block">
                {{ errors.agreement_privacy[0] }}
              </div>
            </div>
          </div>

          <div class="form-group row vc-register-button">
            <div class="col text-center">
              <button
                type="submit"
                class="btn btn-yokumiru-orange"
                :disabled="inProgress || !agreement.term || !agreement.privacy"
                style="width: 100%; max-width: 300px"
              >
                <span v-if="inProgress">処理中です</span>
                <span v-else-if="isOrganization">利用する</span>
                <span v-else>会員登録する</span>
              </button>
            </div>
          </div>
        </form>

        <formrun-association
          :user="user"
          :email="email"
          :utm-content="utmContent"
          :source="source"
          :formrun-uid="uid"
        >
        </formrun-association>
      </div>
    </div>
  </div>
</template>

<script>
import YokumiruHelper from "../../YokumiruHelper";
import constants from "../../constants";

export default {
  props: {
    email: {
      type: String,
      required: true,
    },
    first_name: {
      type: String,
      required: true,
    },
    last_name: {
      type: String,
      required: true,
    },
    utmContent: {
      type: String,
      default: "",
    },
    source: {
      type: String,
      default: "",
    },
    formrunUid: {
      type: String,
      required: true,
    },
    confirmation: {
      type: Object,
      required: true,
    },
  },

  data: function () {
    return {
      helper: YokumiruHelper,
      inProgress: false,
      browserZone: null,
      user: {
        timezone: null,
        last_name: null,
        first_name: null,
        last_name_kana: null,
        first_name_kana: null,
        address: null,
        password: null,
        password_confirmation: null,
        token: null,
      },
      agreement: {
        term: false,
        privacy: false,
      },
      uid: null,
      errors: {},
    };
  },

  computed: {
    /**
     * 団体会員かどうか
     * @return {boolean}
     */
    isOrganization: function () {
      return (
        this.confirmation &&
        this.confirmation.group &&
        this.confirmation.group.group_type === constants.groupType.organization
      );
    },
  },

  created: function () {
    this.uid = this.formrunUid;
    this.user.token = this.$route.query.token;
    this.user.first_name = this.first_name;
    this.user.last_name = this.last_name;
  },

  methods: {
    /**
     * 新規会員登録
     */
    submit: async function () {
      if (this.inProgress) return;
      this.inProgress = true;

      await axios
        .post(constants.user.register.endpoint.base, this.user)
        .then(({ data }) => {
          setTimeout(() => bus.$emit("formrun-submit-required"), 500);
        })
        .catch(({ response }) => {
          if (
            response &&
            response.hasOwnProperty("data") &&
            response.data.hasOwnProperty("errors")
          ) {
            if (response.data.errors.hasOwnProperty("message")) {
              this.errors = {};
              bus.$emit("alert-danger", response.data.errors.message[0]);
            } else {
              this.errors = response.data.errors;
              bus.$emit("alert-danger");
            }
          } else {
            bus.$emit("alert-danger", "システムエラーが発生しました。");
          }

          // 登録が正常完了した場合のリダイレクト中にボタンを再押下させないために catch 内でのみ解除
          this.inProgress = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 950px;
  padding: 0 30px;
  margin: 0 auto;
  box-sizing: border-box;

  @media screen and (max-width:767px) {
      padding: 0 15px;
  }
}

.titleWrapper {
    margin-bottom: 16px;
    text-align: center;
    .subtitleItem {
        margin-bottom: 5px;
        background-color: #F77795;
        color: white;
        border-radius: 10px;
        display: inline-block;
    }
    .titleItem {
        color: #2A2E31;
        font-size: 23px;
        font-weight: bold;
    }
}
.card {
  box-shadow: 0px 4px 12px 0px #00000026;
  border-radius: 0;
  border: none;
  max-width: 950px;
  width: 100%;
  padding: 30px 62px;
}

.card-body {
  max-width: 700px;
  margin: 0 auto;
  padding: 32px;
}

.wide-step-wrapper {
  display: flex;
  justify-content: center;
  margin: 32px 0 24px 0;
  width: 100%;
}

.wide-step-wrapper > * {
  max-width: 850px;
  width: 100%;
}

.form-check-input {
  position: relative;
  width: 1.2rem;
  height: 1.2rem;
  margin: 0;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background-color: #fff;
  cursor: pointer;
  vertical-align: middle;
  line-height: normal;
}



.passwordInfo {
  padding-left: 24px;
  font-size: 13px;
}

.vc-register-title {
  margin: 25px 0 0;
  color: #434343;

  span {
    display: block;

    &:nth-child(1) {
      font-size: 19px;
    }

    &:nth-child(2) {
      margin-top: 8px;
      font-size: 28px;
      font-weight: bold;
    }
  }
}

.vc-campaign {
  text-align: center;

  .vc-campaign__meta {
    .vc-campaign__meta-title {
      color: #e91f63;
      font-size: 26px;
      text-align: center;
    }

    .vc-campaign__meta-description {
      color: #333;
    }
  }
}

.vc-terms a {
  margin-top: 8px;
  margin-bottom: 22px;
  color: #00BFFF;
  text-decoration: underline;
}

.vc-register-button {
  margin-top: 18px;
}

.vc-email-duplicated {
  background: #ffe69a8f;
  padding: 8px 10px;
  border-radius: 4px;

  a {
    text-decoration: underline;
  }
}

#birth_year {
  width: 80px;
}

#birth_month,
#birth_day {
  width: 62px;
}


@media (max-width: 768px) {
  .card {
    max-width: 100%;
    padding: 15px;
  }

  .card-body {
    max-width: 100%;
    padding: 20px 16px;
  }

  .wide-step-wrapper {
    margin: 24px 0;
  }

  .wide-step-wrapper > * {
    max-width: 100%;
  }

  .form-check-input {
  position: relative;
  width: 1.0rem;
  height: 1.0rem;
  margin: 0;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background-color: #fff;
  cursor: pointer;
  vertical-align: middle;
  line-height: normal;
}


  input.form-control {
    width: 100%;
  }

  .form-group.col-lg-12 {
    padding-left: 0;
    padding-right: 0;
  }

  .vc-register-title span:nth-child(2) {
    font-size: 22px;
  }

  .vc-terms {
    font-size: 14px;
  }

  #birth_year,
  #birth_month,
  #birth_day {
    width: 100%;
  }
}
</style>
